export default __webpack_public_path__ + "static/about-img5-0e67ec1feeea62d1003e3a4869f464d6.png";